import { useState, type ReactNode } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

interface GcpCollapsibleProps {
  title: string
  defaultOpen?: boolean
  children: ReactNode
}

export default function GcpCollapsible({
  title,
  defaultOpen = false,
  children,
}: GcpCollapsibleProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="rounded-md border border-gray-200">
      <button
        type="button"
        className="flex w-full items-center justify-between px-3 py-2 text-left text-sm font-medium text-gray-800 hover:bg-gray-50"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        <span>{title}</span>
        {open ? (
          <ChevronUpIcon className="h-4 w-4 shrink-0 text-gray-500" aria-hidden />
        ) : (
          <ChevronDownIcon className="h-4 w-4 shrink-0 text-gray-500" aria-hidden />
        )}
      </button>
      {open ? <div className="border-t border-gray-200 p-3">{children}</div> : null}
    </div>
  )
}
